module.exports = __webpack_public_path__ + "static/img/vip-crownl.9216131b.png";